import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '../shared/shared.module';
import { AuthRoutingModule } from './auth-routing.module';
import { AuthGuard } from './auth.guard';
import { CallbackErrorsComponent } from './callback-errors/callback-errors.component';
import { ExternalLoginCallbackComponent } from './callback/callback.component';
import { LoginComponent } from './login/login.component';
import { OnlyGroupsDirective } from './directives/only-group.directive';

@NgModule({
  declarations: [LoginComponent, ExternalLoginCallbackComponent, CallbackErrorsComponent, OnlyGroupsDirective],
  imports: [CommonModule, AuthRoutingModule, SharedModule, FormsModule, NgbModule, ReactiveFormsModule, RouterModule, FontAwesomeModule],
  providers: [AuthGuard],
  exports: [OnlyGroupsDirective],
})
export class AuthModule {}
